﻿import CreditCardProvider from "../../enums/CreditCardProvider";
import IPermitsPayments from "../IPermitsPayments";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsPayments implements IPermitsPayments {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	async register(creditCardProvider: CreditCardProvider, externalId: string, signal?: AbortSignal | undefined): Promise<string> {
		return this._client.textFetch(`payments/${creditCardProvider}/register`, "POST", null, {
			query: {
				"externalId": externalId
			},
			signal: signal
		});
	}

	public remove(creditCardProvider: CreditCardProvider, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`payments/${creditCardProvider}/clear`, "PUT", null, {
			signal: signal
		});
	}
}
